// extracted by mini-css-extract-plugin
export default {"tabGroup":"style_tabGroup__-0i77","active":"style_active__TtXrR"};